import Axios from 'axios';

const changeUseAppointmentDesk = async (
  listingId: string,
  useAppointmentDesk: boolean,
) => {
  await Axios.post(`/listing/${listingId}/change_use_appointment_desk`, {
    useAppointmentDesk,
  });
};

export default changeUseAppointmentDesk;
